export type SheetSnapPoint = 'collapsed' | 'expanded' | 'minimized';

type SheetSnapOffsets = {
  collapsed: number;
  minimized: number;
};

const SHEET_SWIPE_VELOCITY = 0.35;

export function getSheetSnapOffset(snapPoint: SheetSnapPoint, offsets: SheetSnapOffsets) {
  if (snapPoint === 'expanded') return 0;
  if (snapPoint === 'minimized') return offsets.minimized;
  return offsets.collapsed;
}

export function getSheetReleaseSnapPoint({
  currentOffset,
  velocityY,
  offsets,
}: {
  currentOffset: number;
  velocityY: number;
  offsets: SheetSnapOffsets;
}): SheetSnapPoint {
  const clampedOffset = clampOffset(currentOffset, offsets.minimized);

  if (velocityY < -SHEET_SWIPE_VELOCITY) {
    return clampedOffset > offsets.collapsed ? 'collapsed' : 'expanded';
  }

  if (velocityY > SHEET_SWIPE_VELOCITY) {
    return clampedOffset < offsets.collapsed ? 'collapsed' : 'minimized';
  }

  return getNearestSheetSnapPoint(clampedOffset, offsets);
}

function getNearestSheetSnapPoint(offset: number, offsets: SheetSnapOffsets): SheetSnapPoint {
  const snapPoints: { offset: number; snapPoint: SheetSnapPoint }[] = [
    { offset: 0, snapPoint: 'expanded' },
    { offset: offsets.collapsed, snapPoint: 'collapsed' },
    { offset: offsets.minimized, snapPoint: 'minimized' },
  ];

  return snapPoints.reduce((nearest, current) =>
    Math.abs(current.offset - offset) < Math.abs(nearest.offset - offset) ? current : nearest
  ).snapPoint;
}

export function clampSheetOffset(offset: number, maxOffset: number) {
  return clampOffset(offset, maxOffset);
}

function clampOffset(offset: number, maxOffset: number) {
  return Math.min(maxOffset, Math.max(0, offset));
}
